import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email, min, confirmed } from "vee-validate/dist/rules";

extend('verify_password', {
    message:
        `The password must contain at least: 1 uppercase letter, 1 lowercase letter and 1 number`,
    validate: value => {
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])')
        return strongRegex.test(value)
    }
})

extend('confirmed', {
    ...confirmed,
    message: "The passwords do not match"
})

extend('min', {
    ...min,
    message: (field, min) => `This field must be at least ${min.length} characters`
})

extend("required", {
    ...required,
    message: "This field is required"
});

extend("email", {
    ...email,
    message: "This field must be a valid email"
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);